import { AxiosResponse } from 'axios'
import api from '~/services/api'
import { ILockResponse } from './../model/types'

export const lock = async (requestData: string, tableId: string) => {
  const { data }: AxiosResponse<ILockResponse> = await api.get(`shop/availability/${requestData}?table_id=${tableId}`)
  return data
}
